import "./App.css";
import i18n from "./config/i18n";
import MyRoutes from "./routes/Routes";

function App() {
  let a = i18n;
  return <MyRoutes />;
}

export default App;
